import React from "react";
import { useNavigate } from "react-router-dom";

import { proper } from "lib/common/proper";

import { useRecoilValueLoadable } from "recoil";
import { asyncGetProject } from "lib/store/project";

import { CloseIcon, FaceIcon } from "@atsent/components";

import { Profile } from "components/atom/Profile";
import { Skeleton } from "components/atom/Skeleton";
import { ProjectAlarm } from "components/template/Alarm";

import "./Header.scss";

export type HeaderProps = {
  cx?: string;
};

export const Header: React.FC<HeaderProps> = ({ cx = "" }) => {
  const project = useRecoilValueLoadable(asyncGetProject);
  const navigate = useNavigate();
  return (
    <header className={`SidebarHeader ${cx}`}>
      <div className={"title-wrapper"}>
        <FaceIcon cx={project.contents?.sentiment} />
        {project.state === "hasValue" ? (
          <>
            <span className={"title"}>{project.contents?.name}</span>
            <div className={"separator"}>|</div>
            <span>{proper(project.contents?.category || "")}</span>
          </>
        ) : (
          <>
            <Skeleton />
            <div className={"separator"}>|</div>
            <Skeleton cx={"small"} />
          </>
        )}
        <CloseIcon onClick={() => navigate("/")} />
      </div>
      <div className="right-wrapper">
        <ProjectAlarm />
        <Profile />
      </div>
    </header>
  );
};
